import { useState } from 'react';
import { useRecoilState } from 'recoil';
import XIcon from '../assets/icons/x';
import { isVoiceSettingsOpen, voicePersona } from '../recoil';
import { VoiceOptionInterface, VoiceOptions } from '../resources/VoiceOptions';
const SettingsCard = () => {
  const [selectedOption, setSelectedOption] =
    useState<VoiceOptionInterface | null>(null);

  const handleOptionClick = (option: VoiceOptionInterface) => {
    setSelectedOption(option);
  };

  const [settingsCardOpen, setSettingsCardOpen] =
    useRecoilState(isVoiceSettingsOpen);
  const [voicePersonaOption, setVoicePersonaOption] =
    useRecoilState(voicePersona);

  const handleConfirmButtonClick = () => {
    if (selectedOption) {
      setSettingsCardOpen(false);
      setVoicePersonaOption({
        DisplayName: selectedOption.DisplayName,
        AzureCode: selectedOption.AzureCode,
      });
    }
  };

  return (
    <div className=" relative flex h-[400px] w-full flex-col items-center  justify-start gap-10  rounded-t-xl bg-[#242424] p-4">
      <div className=" absolute right-6">
        <button onClick={() => setSettingsCardOpen(false)}>
          <XIcon />
        </button>
      </div>
      <div className=" font-['Graphik'] text-xl font-medium text-white">
        Select a voice
      </div>

      <div className=" flex h-full w-full flex-col gap-4 overflow-y-scroll">
        {VoiceOptions.map((option: VoiceOptionInterface, index: number) => (
          <div
            key={index}
            className={`flex min-h-[50px] w-full rounded-lg p-4 font-['Graphik'] font-medium text-white ${
              selectedOption === option
                ? 'bg-[#a200ff57]'
                : 'bg-[#323131aa] hover:bg-[#4c4b4baa]'
            }`}
            onClick={() => handleOptionClick(option)}
          >
            {option.DisplayName}
          </div>
        ))}
      </div>
      <button className=" w-full" onClick={() => handleConfirmButtonClick()}>
        <div className=" flex w-full items-center justify-center rounded-lg bg-white p-3">
          <text className=" font-['Graphik'] font-medium"> Confirm </text>
        </div>
      </button>
    </div>
  );
};

export default SettingsCard;
